import React from "react";
import {
    DatePicker,
    Button,
    Space,
    Row,
    Col,
    Dropdown,
    Checkbox,
    Select,
    Modal,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";

import { PlusOutlined, DownOutlined } from "@ant-design/icons";
import withRouter from "../withRouter";
import ListTable from "./ListTable";
import DriverExpenseReportStore from "../store/DriverExpenseReportStore.js";
import CompanyAutocomplete from "./CompanyAutocomplete";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import DriverLoginReportStore from "../store/DriverLoginReportStore.js";
dayjs.extend(customParseFormat);

const { RangePicker } = DatePicker;
const { Option } = Select;
class DriverExpenseReport extends React.Component {
    constructor(props, context) {
        super(props);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);

        this.handleTableChange = this.handleTableChange.bind(this);
        this.driverExpenseReportStore = new DriverExpenseReportStore();
        this.driverLoginReportStore = new DriverLoginReportStore();

        this.state = {
            loading: false,
            pageSize: 50,
            currentPage: 1,
            company_name: "",
            listUpdated: 0,
            companyId: "",
            selectedDriver: [],
            selectAllDrivers: false,
            date: "",
            time: "",
            fromDate: dayjs().format("YYYY-MM-DD"),
            toDate: dayjs().format("YYYY-MM-DD"),
            modalVisible: false,
            column: "",
            filter: "",
            showMonthPopup: false,
            Notcompany: false,
            selectedColumns: [
                {
                    // title: "User Name",
                    title: context.translate("_DRIVER_"),
                    dataIndex: "driverName",
                    key: "driverName",
                    width: "15%",
                },
                {
                    // title: "Password",
                    title: context.translate("_EXPANSE_TYPE_"),
                    dataIndex: "expanceType",
                    key: "expanceType",
                    width: "15%",
                },
                {
                    // title: "Login DateTime",
                    title: context.translate("_DATE_"),
                    dataIndex: "date",
                    key: "date",
                    width: "15%",

                },
                {
                    // title: "Login IP ",
                    title: context.translate("_TOTAL_AMMOUNT_"),
                    dataIndex: "totalAmount",
                    key: "totalAmount",
                    width: "15%",
                }

            ],
        };
        this.menuProps = {
            items: [
                {
                    // label: "Excel",
                    label: context.translate("_EXCEL_"),
                    key: "excel",
                    icon: <PlusOutlined />,
                },

                {
                    // label: "PDF",
                    label: context.translate("_PDF_"),
                    key: "pdf",
                    icon: <PlusOutlined />,
                },
            ],
            onClick: (val) => {
                const result = [];
                if (this.driverExpenseReportStore.rec) {
                    this.newColumns.map((obj) => result.push(obj.dataIndex));
                    var getDta = {
                        companyId: this.state.companyId,
                        fromDate: this.state.fromDate,
                        toDate: this.state.toDate,
                        colList: result.toString(),
                        driverId: this.state.selectedDriver
                    };
                    if (val.key == "excel") {
                        this.driverExpenseReportStore.exportExcel(getDta);
                    }
                    if (val.key == "pdf") {
                        this.driverExpenseReportStore.exportpdf(getDta);
                    }

                }
            },
        };
        this.newColumns = [...this.state.selectedColumns];
    }

    async componentDidMount() {
        this.setState({ pageSize: 50 });
        await this.setState({ column: this.state.selectedColumns });

        if (Number(this.props.getUserData().isadmin) !== -1) {
            let companyId = this.props.getUserData().userCompanyId;

            this.setState({ companyId: companyId });
            this.handleChange({ value: companyId });
        }

        await this.setState({ listUpdated: 1 });

        // await this.setState({ listUpdated: 1 });
    }
    handleSelectAllDrivers = async (e) => {
        if (this.state.selectAllDrivers) {
            const allDrivers = this.driverLoginReportStore?.getDrivers.map((val) => {
                return val.driverId;
            });
            await this.setState({ selectedDriver: allDrivers });
        } else {
            await this.setState({ selectedDriver: [] });
        }
    };


    async handleTableChange(pagination, filters, sorter) {
        //   console.log(pagination);
        await this.setState({
            currentPage: pagination.current,
            pageSize: pagination.pageSize,
        });
        // this.handleSearch();
        await this.showData();
    }

    async handleChange(comp) {
        await this.setState({ Notcompany: false, selectedUser: "" });
        await this.setState({ currentPage: 1, companyId: comp?.value });
        await this.setState({ selectedDriver: [], selectAllDrivers: false });
        await this.driverLoginReportStore.getDriversByCompanyId({
            companyId: comp.value,
        });

        await this.setState({ listUpdated: 1 });
    }

    async handleSearch() {
        await this.driverExpenseReportStore.loadData({
            offset: (this.state.currentPage - 1) * this.state.pageSize,
            limit: this.state.pageSize,
            companyId: this.state.companyId,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            driverId: this.state.selectedDriver,
        });
        await this.setState({ listUpdated: 1 }); //need to reload data
    }
    showData = async () => {
        if (!this.state.companyId) {
            this.setState({ Notcompany: true });
        } else {
            this.setState({ Notcompany: false });
        }
        if (this.state.companyId) {
            // this.setState({mandatory:false})
            this.setState({ Notcompany: false });
            if (this.checkFromDate(this.state.fromdateStdTime)) {
                await this.driverExpenseReportStore.loadData({
                    offset: (this.state.currentPage - 1) * this.state.pageSize,
                    limit: this.state.pageSize,
                    companyId: this.state.companyId,
                    fromDate: this.state.fromDate,
                    toDate: this.state.toDate,
                    driverId: this.state.selectedDriver,
                });
                await this.setState({ listUpdated: 1 });
            }
        }
    };
    addMonths = (date, months) => {
        var indx = dayjs().month() + -6;
        return dayjs().month(indx);
    };

    checkFromDate(dates) {
        var fromDate = dates;
        var pdate = this.addMonths();
        if (pdate > fromDate) {
            this.setState({ showMonthPopup: true });
            return false;
        } else {
            return true;
        }
    }
    onDateTimeChange = (dates) => {
        if (dates) {
            const format = "YYYY-MM-DD";
            this.setState({
                fromdateStdTime: dates[0],
                fromDate: dates[0]?.format(format),
                toDate: dates[1]?.format(format),
            });
        }
    };
    handleCheckboxChange = async (column) => {
        if (this.state.selectedColumns.some((c) => c.key === column.key)) {
            const filtered = this.state.selectedColumns.filter(
                (c) => c.key !== column.key
            );

            await this.setState({
                selectedColumns: filtered,
            });
            await this.setState({ column: filtered });
            // await  this.updateVisibleColumns();
        } else {
            await this.setState({
                selectedColumns: [...this.state.selectedColumns, column],
                column: [...this.state.selectedColumns, column],
            });
            // await  this.updateVisibleColumns();
        }
    };

    updateVisibleColumns = () => {
        this.setState({ column: this.state.selectedColumns });
    };

    render() {
        const companyInputStyle = this.state.Notcompany
            ? { border: "1px solid red", width: "150px", borderRadius: "8px" }
            : { width: "150px" };

        return (
            <>
                <div style={{ padding: 0 }}>
                    <Row className="headerFixed" style={{ height: "50px" }}>
                        <Col span={12}>
                            {/* <div className="heading">User Login Report</div> */}
                            <div className="heading">
                                {this.context.translate("_DRIVER_EXPANCE_REPORT_")}
                            </div>
                        </Col>
                        <Col
                            span={12}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                        >
                            <Space
                                style={{
                                    float:
                                        this.context.locale.direction == "ltr" ? "right" : "left",
                                }}
                            >

                                <Button onClick={() => this.setState({ modalVisible: true })}>
                                    {/* Columns */}
                                    {this.context.translate("_COLUMNS_")}
                                </Button>

                                <Dropdown
                                    menu={this.menuProps}
                                    disabled={
                                        this.driverExpenseReportStore?.expenseReport?.length > 0
                                            ? false
                                            : true
                                    }
                                >
                                    <Button className="exportDropdown"
                                    >
                                        <Space>
                                            {/* Export */}
                                            {this.context.translate("_EXPORT_")}
                                            <DownOutlined />
                                        </Space>
                                    </Button>
                                </Dropdown>

                            </Space>
                        </Col>
                    </Row>
                </div>
                <div
                    style={{
                        paddingTop: "10px",
                        paddingRight: "24px",
                        paddingLeft: "24px",
                    }}
                >
                    <Row className="listInputRow">
                        <Space>
                            <Col span={16}>
                                <CompanyAutocomplete
                                    allowClear={true}
                                    onChange={(value) => this.handleChange(value)}
                                    style={{ width: 150 }}
                                    // style={companyInputStyle}
                                    status={this.state.Notcompany ? "error" : false}
                                />
                            </Col>

                            <Col>

                                <>
                                    <Checkbox
                                        checked={this.state.selectAllDrivers}
                                        onChange={async (e) => {
                                            await this.setState({
                                                selectAllDrivers: e.target.checked,
                                            });
                                            if (this.state.selectAllDrivers) {
                                                await this.setState({
                                                    Notdriver: false,
                                                });
                                            }

                                            await this.handleSelectAllDrivers();
                                        }}
                                    />{" "}
                                    {this.context.translate("_ALL_")}
                                    &nbsp;
                                    <Select
                                        // onSearch={this.handleSearch}
                                        mode="multiple"
                                        value={this.state.selectedDriver}
                                        maxTagCount="responsive"
                                        onChange={(val) => {
                                            this.setState({
                                                selectedDriver: val,
                                                Notdriver: false,
                                            });
                                            if (
                                                this.driverLoginReportStore?.getDrivers.length >
                                                val.length
                                            ) {
                                                this.setState({ selectAllDrivers: false });
                                            } else {
                                                this.setState({ selectAllDrivers: true });
                                            }
                                        }}
                                        placeholder={this.context.translate(
                                            "_FLEET_DASHBORD_VEHICLE_INFORMATION_DRIVERNAME_"
                                        )}
                                        optionFilterProp="children"
                                        style={{ width: 150 }}

                                        status={this.state.Notdriver ? "error" : false}
                                        filterOption={(inputValue, option) => {
                                            if (option.children) {
                                                return (
                                                    option.children
                                                        .toLowerCase()
                                                        .indexOf(inputValue.toLowerCase()) >= 0
                                                );
                                            }
                                        }}
                                    >
                                        {this.driverLoginReportStore?.getDrivers?.map((val) => {
                                            return <Option value={val.driverId}>{val.name}</Option>;
                                        })}
                                    </Select>
                                </>


                            </Col>
                            <Col>
                                <RangePicker
                                    placeholder={["From Date", "To Date"]}
                                    format="DD-MM-YYYY"
                                    style={{ width: 400 }}
                                    onChange={(dates) => {
                                        this.onDateTimeChange(dates);
                                    }}
                                    // disabledDate={(current) =>
                                    //     current && current > dayjs().endOf("day")
                                    // }
                                    defaultValue={[
                                        dayjs().startOf("day"),
                                        dayjs().startOf("day")
                                    ]}
                                />

                            </Col>

                            {/* <TimePicker onChange={this.onTimeChange} defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')} /> */}

                            <Col>
                                <Button
                                    type="primary"
                                    onClick={async () => {
                                        await this.setState({ currentPage: 1, pageSize: 50 });
                                        await this.showData();

                                    }}
                                >
                                    {" "}
                                    {/* Show */}
                                    {this.context.translate("_FLEET_SHOW_BTN_")}
                                </Button>
                            </Col>
                        </Space>
                    </Row>

                    <Modal
                        open={this.state.modalVisible}
                        width={300}
                        // title="Select Columns"
                        title={this.context.translate("_SELECT_COLUMNS_")}
                        onCancel={() => this.setState({ modalVisible: false })}
                        onOk={() => {
                            this.setState({ modalVisible: false });
                        }}
                        footer={null}
                    >
                        <div style={{ maxHeight: "400px", overflowY: "auto" }}>

                            {this.newColumns.map((column, v) => {
                                return (
                                    <Row key={v}>
                                        <Col>
                                            <Checkbox
                                                onChange={() => this.handleCheckboxChange(column)}
                                                checked={this.state.selectedColumns.some(
                                                    (c) => c.key === column.key
                                                )}
                                            >
                                                {column.title}
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                );
                            })}
                        </div>
                    </Modal>

                    <ListTable
                        currentPage={this.state.currentPage}
                        pageSize={this.state.pageSize}
                        total={this.driverExpenseReportStore?.total}
                        columns={this.state.column}
                        dataSource={this.driverExpenseReportStore?.expenseReport}

                        loading={this.driverExpenseReportStore?.loading}
                        onChange={this.handleTableChange}
                    />

                    <Modal
                        open={this.state.showMonthPopup}
                        title={
                            <div>
                                {" "}
                                <i
                                    style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                                    class="bi bi-exclamation-triangle"
                                ></i>{" "}
                                {this.context.translate("_FLEET_ALERT_")}
                            </div>
                        }
                        onOk={() => this.setState({ showMonthPopup: false })}
                        onCancel={() => this.setState({ showMonthPopup: false })}
                        footer={false}
                    >
                        {/* For Reports prior to 6 months please contact administrator */}
                        {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
                    </Modal>
                </div>
            </>
        );
    }
}
DriverExpenseReport.contextType = StoreContext;
export default observer(withRouter(DriverExpenseReport));
